import { BranchWorkerAccountTypes } from './branch/SitterBranchWorker';

export enum PayoutMethodProvider {
  CHECKR = 'checkr',
  BRANCH = 'branch',
}

export enum PayoutMethodStatus {
  ACTIVE = 'active',
  CLOSED = 'closed',
  NO_ACCOUNT = 'no_account',
  PENDING = 'pending'
}

export interface PayoutMethod {
  accountType?: BranchWorkerAccountTypes;
  hasBalance?: boolean;
  provider?: PayoutMethodProvider;
  sitterId?: number;
  status?: PayoutMethodStatus;
}
